import { Component, Input, OnInit } from '@angular/core';
import { SubscriptionManager } from '../../../shared/subscription-manager/subscription-manager.class';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../../models/user-data';
import { Documento, PagamentoUnipayRequest, Rata } from '../../../models/payment-notices-response';
import { MessageService } from '../../../services/message.service';
import { PaymentnoticesService } from '../../../services/paymentnotices.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { ConfigurazioneGeneraleService } from '../../../services/configurazione-generale.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'jhi-dettaglio-pagamento-tributi',
  templateUrl: './dettaglio-pagamento-tributi.component.html',
  styleUrls: ['./dettaglio-pagamento-tributi.component.scss']
})
export class DettaglioPagamentoTributiComponent extends SubscriptionManager implements OnInit {
  loading = false;
  userData: UserData;
  pagamento?: Documento;
  isPdfPagoPaPresent = false;
  @Input() noStyle?: boolean;
  @Input() rataDaPagare?: Observable<Rata>;
  cdTributo : string = ''

  constructor(private activatedRoute : ActivatedRoute, private router: Router, private configurazioneGeneraleService: ConfigurazioneGeneraleService, private messageService: MessageService, private paymentNoticesService: PaymentnoticesService, private alertService: AlertService) {
    super();
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
    if (this.userData.email) {
      if (!this.userData.email.includes('@')){
        this.userData.email = null;
      }
    }
  }

  ngOnInit(): void {
    this.cdTributo = this.activatedRoute.snapshot.params["cdTributo"];
    this.messageService.pagamentoTributoMessage.subscribe((pg) => {
      this.pagamento = pg;
      this.checkRatePdf();
    })
    this.rataDaPagare?.subscribe({
      next: (res) => {
        this.paga(res);
      }
    })
    if(localStorage.getItem("pagamentoSelezionato")){
      this.pagamento = JSON.parse(<string>localStorage.getItem("pagamentoSelezionato"));
      this.checkRatePdf();
    }

  }

  goToListaPagamenti():void{
    return void this.router.navigate(['Servizi/PagamentoTributi']).then();
  }

  goToServizi():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkServizi;
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  downloadPdf(pdf: string):void{
    if(pdf){
      const src = `data:application/pdf;base64,${pdf}`;
      const link = document.createElement("a");
      link.href = src;
      link.download = "Avviso_" + this.pagamento?.Numero;
      link.click();
      link.remove();
    }
  }

  sommaRatePagamenti(rate: Array<Rata>): number{
    return rate.reduce((acc, cur) => acc + cur.Importo, 0);
  }

  createUnipayBody(rata: Rata): PagamentoUnipayRequest{
    const protocol = window.location.protocol; // 'http:' or 'https:'
    const host = window.location.host;         // 'example.com' or 'example.com:4200'
    const baseUrl = `${protocol}//${host}`;
    return {
      //codiceEnte: rata.RiferimentiPagopa.codiceEnte, Da reimpostare una volta che arriva pagoPa
      codiceEnte: "cnvvf",
      idOperazione: rata && rata.RiferimentiPagopa && rata.RiferimentiPagopa.idOperazione ? rata.RiferimentiPagopa.idOperazione : '',
      //contesto: rata.RiferimentiPagopa.contesto,
      contesto: "contesto_test_243n73_d3l1v3r",
      importoInCents: this.convertToCents(rata.ImportoRidotto ? rata.ImportoRidotto : rata.Importo),
      cognome: <string>this.userData.cognome,
      //codServizio: rata.RiferimentiPagopa.servizio,
      codServizio: "contesto_test_243n73_d3l1v3r",
      codiceEntrata: rata && rata.RiferimentiPagopa && rata.RiferimentiPagopa.codiceEntrata ? rata.RiferimentiPagopa.codiceEntrata : '',
      tipoIdUnivocoDebitore: rata && rata.RiferimentiPagopa && rata.RiferimentiPagopa.idUnivocoDebitoreTipo ? rata.RiferimentiPagopa.idUnivocoDebitoreTipo : '',
      idUnivocoDebitore: rata && rata.RiferimentiPagopa && rata.RiferimentiPagopa.idUnivocoDebitore ? rata.RiferimentiPagopa.idUnivocoDebitore : '',
      causale: <string>this.pagamento?.Descrizione,
      email: <string>this.userData.email,
      IUV: <string>rata.Iuv,
      returnCancelUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${this.pagamento?.Numero.toString()}?cdTributo=${this.cdTributo}&status=Annullato`,
      returnOkUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${this.pagamento?.Numero.toString()}?cdTributo=${this.cdTributo}&status=Terminato`,
      returnErrorUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${this.pagamento?.Numero.toString()}?cdTributo=${this.cdTributo}&status=Errore`
    }
  }



  convertToCents(importo: number): string {
    const cents = importo * 100;
    const centesimiStringa = cents.toFixed(0);
    return centesimiStringa;
  }

  paga(rata: Rata): void{
    const requestBody = this.createUnipayBody(rata);
    this.loading = true;
    this.paymentNoticesService.getPagoPaRedirectUrl(requestBody).subscribe((res) => {
      this.loading = false;
      if(res.redirectUrl){
        this.openNewTabOrNewWindow(res.redirectUrl);
      }
    },
      (err) => {
        this.loading = false;
        if(err.error.detail){
          this.alertService.creaAlert("Tributo giá pagato o in fase di aggiornamento", "warning", "sticky", 5000, true)
        }
      })
  }

  openNewTabOrNewWindow(targetURL: string): void {
    const a = document.createElement('a');
    a.href = targetURL;

    a.target = '_blank'; // now it will open new tab/window and bypass any popup blocker!

    this.fireClickEvent(a);
  }

  checkRatePdf(): void{
    this.isPdfPagoPaPresent = false;
    this.pagamento?.Rate.forEach((rata) => {
      if(rata.PdfPagopa){
        this.isPdfPagoPaPresent = true;
      }
    })
  }

   fireClickEvent(element: HTMLAnchorElement): void {
    const evt = new window.MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });

    element.dispatchEvent(evt);
  }
}
